<template>
  <Flex
    :class="[$style.base, { [$style.sensitive]: sensitive }]"
    @click="toggle"
    direction="column"
    align="center"
    :gap=".5"
  >
    <BaseIcon
      v-if="sensitive && hide"
      name="invisible"
      color="primary"
      v-test="'statsSensitiveContent'"
    />
    <BaseHeading
      v-else
      size="xl"
    >
      <div v-if="currency">{{ filters.currency(value) }}</div>
      <div v-else>{{ value }}</div>
    </BaseHeading>
    <BaseHeading
      size="s"
      noWrap
    >
      {{ text }}
    </BaseHeading>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import filters from '@/filters';

defineProps<{
  value: number;
  text: string;
  sensitive?: boolean;
  currency?: boolean;
}>();

const hide = ref(true);

const toggle = () => {
  hide.value = !hide.value;
};
</script>

<style
  lang="scss"
  module
>
.base {
  flex: 1;
}

.sensitive {
  cursor: pointer;
}
</style>
